import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import JBImage from 'components/essentials/JBImage';

const CDNImageManager = props => {
  if (props.src && props.src.includes('images.ctfassets.net')) {
    return (
      <img
        height={props.height}
        width={props.width}
        src={props.src}
        alt="mobile slider"
      />
    );
  }
  return <JBImage {...props} />;
};

const MobileSlider = ({ slides, imageWidth, imageHeight, sizes }) => (
  <div className="overflow-hidden">
    <div
      className={classNames(
        '-ml-5 -mr-5 pl-5 pr-5 flex overflow-scroll overflow-y-hidden',
        'max-[767px]:ml-0 max-[767px]:mr-0 max-[767px]:pl-5 max-[767px]:pr-5',
        '[&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]'
      )}
    >
      {slides.map(image => {
        const imageUrl = image.value || image.src || image.url;

        return (
          <div
            className="flex-[1_1] min-w-[75%] flex-col justify-between items-center pr-5"
            key={imageUrl}
          >
            <div className="h-0 mb-0 overflow-hidden pt-[100%] relative [&_img]:absolute [&_img]:top-0 [&_img]:left-0 [&_img]:bottom-0 [&_img]:right-0 [&_img]:w-full [&_img]:h-full">
              <CDNImageManager
                key={imageUrl}
                src={imageUrl}
                width={imageWidth}
                height={imageHeight}
                trim="auto"
                sizes={sizes}
                lazy
              />
            </div>
          </div>
        );
      })}
    </div>
  </div>
);

CDNImageManager.propTypes = {
  src: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

MobileSlider.propTypes = {
  slides: PropTypes.arrayOf(PropTypes.string),
  imageWidth: PropTypes.number,
  imageHeight: PropTypes.number,
  sizes: PropTypes.string,
};

export default MobileSlider;
